import { render, staticRenderFns } from "./VirHomePart2.vue?vue&type=template&id=0131623a&scoped=true&"
import script from "./VirHomePart2.vue?vue&type=script&lang=js&"
export * from "./VirHomePart2.vue?vue&type=script&lang=js&"
import style0 from "./VirHomePart2.vue?vue&type=style&index=0&id=0131623a&prod&scoped=true&lang=scss&"
import style1 from "./VirHomePart2.vue?vue&type=style&index=1&id=0131623a&prod&scoped=true&lang=scss&"
import style2 from "./VirHomePart2.vue?vue&type=style&index=2&id=0131623a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0131623a",
  null
  
)

export default component.exports